import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import casinoWS from '../services/websocket';

const BalanceContext = createContext(null);

export const BalanceProvider = ({ children }) => {
  const [balance, setBalance] = useState('0');

  useEffect(() => {
    const unsubscribers = [];
    const timerIds = [];

    // Direct balance events
    unsubscribers.push(casinoWS.on('init', (data) => {
      setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('balance', (data) => {
      setBalance(data.balance);
    }));

    // Mines
    unsubscribers.push(casinoWS.on('minesGameStarted', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('minesTileResult', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('minesCashOut', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    // Dice
    unsubscribers.push(casinoWS.on('diceResult', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('diceError', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    // Chicken Cross
    unsubscribers.push(casinoWS.on('chickenState', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('chickenResult', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    // Wheel
    unsubscribers.push(casinoWS.on('wheelState', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('wheelSpinResult', (data) => {
      if (data.balance !== undefined) {
        timerIds.push(setTimeout(() => setBalance(data.balance), 1300));
      }
    }));

    unsubscribers.push(casinoWS.on('wheelCashOut', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    // Keno
    unsubscribers.push(casinoWS.on('kenoResult', (data) => {
      if (data.balance !== undefined) {
        timerIds.push(setTimeout(() => setBalance(data.balance), 2400));
      }
    }));

    // Limbo
    unsubscribers.push(casinoWS.on('limboResult', (data) => {
      if (data.balance !== undefined) {
        timerIds.push(setTimeout(() => setBalance(data.balance), 500));
      }
    }));

    // Crash
    unsubscribers.push(casinoWS.on('crashBetConfirmed', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    unsubscribers.push(casinoWS.on('crashCashoutConfirmed', (data) => {
      if (data.balance !== undefined) setBalance(data.balance);
    }));

    return () => { unsubscribers.forEach(unsub => unsub()); timerIds.forEach(clearTimeout); };
  }, []);

  const value = useMemo(() => ({ balance, setBalance }), [balance]);

  return (
    <BalanceContext.Provider value={value}>
      {children}
    </BalanceContext.Provider>
  );
};

export const useBalance = () => {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error('useBalance must be used within a BalanceProvider');
  }
  return context;
};

export default BalanceContext;
